var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 8.5C6.25 5.32436 8.82436 2.75 12 2.75C15.1756 2.75 17.75 5.32436 17.75 8.5V11.5C17.75 14.6756 15.1756 17.25 12 17.25C8.82436 17.25 6.25 14.6756 6.25 11.5V8.5ZM7.81597 7.75H9C9.41421 7.75 9.75 8.08579 9.75 8.5C9.75 8.91421 9.41421 9.25 9 9.25H7.75V10.75H9C9.41421 10.75 9.75 11.0858 9.75 11.5C9.75 11.9142 9.41421 12.25 9 12.25H7.81597C8.1702 14.2395 9.9087 15.75 12 15.75C14.0913 15.75 15.8298 14.2395 16.184 12.25L13.5 12.25C13.0858 12.25 12.75 11.9142 12.75 11.5C12.75 11.0858 13.0858 10.75 13.5 10.75L16.25 10.75V9.25H13.5C13.0858 9.25 12.75 8.91421 12.75 8.5C12.75 8.08579 13.0858 7.75 13.5 7.75H16.184C15.8298 5.76049 14.0913 4.25 12 4.25C9.9087 4.25 8.1702 5.76049 7.81597 7.75ZM4 9.75C4.41421 9.75 4.75 10.0858 4.75 10.5V11.5C4.75 15.5041 7.99594 18.75 12 18.75C16.0041 18.75 19.25 15.5041 19.25 11.5V10.5C19.25 10.0858 19.5858 9.75 20 9.75C20.4142 9.75 20.75 10.0858 20.75 10.5V11.5C20.75 16.0798 17.2314 19.8379 12.75 20.2183V22.5C12.75 22.9142 12.4142 23.25 12 23.25C11.5858 23.25 11.25 22.9142 11.25 22.5V20.2183C6.7686 19.8379 3.25 16.0798 3.25 11.5V10.5C3.25 10.0858 3.58579 9.75 4 9.75Z",
    fill: "#1E2D66",
    stroke: "#1E2D66",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.4e7110134ca154bd46d80b4eabccca24.svg";
export { ForwardRef as ReactComponent };